// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__19see","label":"SetPasswdForm_label__g1cqO"};